<template>
  <div>
    <Form ref="searchForm" inline :label-width="70" class="search-form">
      <Form-item label="课程名称">
        <Input
          style="width:200px"
          placeholder="请输入课程名称关键字"
          v-model="searchCondition.title"
          clearable
          @keydown.native.prevent.enter="search"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/vipCourse"
        method="get"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        :selectType="selectType"
        keyField="vip_course_id"
        :selectedItems="selectedItems"
        keepSelected
      >
        <template slot="footer-left">
          <Button
            icon="ios-refresh"
            class="btn-margin-right"
            type="text"
            @click="search(1)"
            style="margin-left:5px;"
          >刷新</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
import * as enums from "../../utils/enums";

export default {
  name: "VipSelect",
  data() {
    return {
      columns: [
        {
          title: "课程名称",
          key: "title"
        },
        {
          title: "课程类型",
          key: "course_type"
        }
      ],
      selectList: [],
      searchCondition: {
        title: ""
      }
    };
  },
  props: {
    selectedItems: {
      type: Array
    },
    selectType: {
      type: String,
      default: "multi"
    },
    status: {
      type: Number
    }
  },
  created() {
    if (this.status !== undefined) {
      this.searchCondition.status = this.status;
    }
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(i => {
        i.course_type = enums.CouseType.getValue(i.course_type);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.keywords = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = [...val];
    },
    getSelectList() {
      return this.selectList;
    },
    recoverSelectedItems(selectedItems) {
      this.$refs.grid.recoverSelectedItems(selectedItems);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>